import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import MojitoServices from 'mojito/services';
import { apcaSettingsToPriceChangePolicies } from 'modules/betting-settings/utils.js';

const {
    actions: betslipActions,
    selectors: { selectBetslipSettings },
} = MojitoServices.Betslip;
const { selectUserInfo } = MojitoServices.UserInfo.selectors;

/**
 * HoC wraps CommitBetslipButton implementation with sports betslip specific handling.
 *
 * @function withSportPlaceBet
 * @param {React.ReactElement} CommitBetslipButton - Place bet button view implementation.
 * @returns {React.ReactElement} Place bet button react component.
 * @memberof Mojito.Modules.BetslipView
 * @private
 */
export default function withSportPlaceBet(CommitBetslipButton) {
    return function PlaceSportBetButton(props) {
        const dispatch = useDispatch();

        const { priceChangeAcceptance, userInfo } = useSelector(
            state => ({
                priceChangeAcceptance: selectBetslipSettings(state)?.priceChangeAcceptance,
                userInfo: selectUserInfo(state),
            }),
            shallowEqual
        );

        const onPlaceBet = () => {
            const priceChangePolicies = apcaSettingsToPriceChangePolicies(priceChangeAcceptance);
            dispatch(betslipActions.placeBetslip({ priceChangePolicies, userInfo }));
        };
        const onAcceptPriceChanges = () => dispatch(betslipActions.acceptChanges());

        return (
            <CommitBetslipButton
                {...props}
                onCommit={onPlaceBet}
                class="ta-PlaceBetButton"
                onAcceptPriceChanges={onAcceptPriceChanges}
            />
        );
    };
}
